export default "__VITE_ASSET__49ed2ff7__"